// extracted by mini-css-extract-plugin
export default {"box":"searchStyle_box__JIc1m","btn":"searchStyle_btn__2JnTl","input":"searchStyle_input__DdvAU"};